import { render, staticRenderFns } from "./CustomPayment-175.vue?vue&type=template&id=65627c52&scoped=true&"
import script from "./CustomPayment-175.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-175.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-175.vue?vue&type=style&index=0&id=65627c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65627c52",
  null
  
)

export default component.exports